import { InteractionType } from '../interactions/index.js';
export var TemplateGroupStates;
(function (TemplateGroupStates) {
    TemplateGroupStates["PUBLISHED_WIP"] = "PUBLISHED WORK IN PROGRESS";
    TemplateGroupStates["PUBLISHED"] = "PUBLISHED";
    TemplateGroupStates["NEVER_PUBLISHED"] = "NEVER PUBLISHED";
    TemplateGroupStates["WIP"] = "WORK IN PROGRESS";
})(TemplateGroupStates || (TemplateGroupStates = {}));
export var TemplateState;
(function (TemplateState) {
    TemplateState["PUBLISHED"] = "PUBLISHED";
    TemplateState["DRAFT"] = "DRAFT";
    TemplateState["VERSION"] = "VERSION";
})(TemplateState || (TemplateState = {}));
export var TemplateType;
(function (TemplateType) {
    TemplateType["EMAIL"] = "email";
    TemplateType["LETTER"] = "letter";
    TemplateType["SMS"] = "sms";
    TemplateType["AUTOCALL"] = "autocall";
    TemplateType["EBOKS"] = "eboks";
    TemplateType["KIVRA"] = "kivra";
    TemplateType["DIGIPOST"] = "digipost";
    TemplateType["CREDITOR_MESSAGE"] = "creditor-message";
    TemplateType["DEBTOR_MESSAGE"] = "debtor-message";
    TemplateType["NOTE"] = "note";
})(TemplateType || (TemplateType = {}));
const templateTypeByInteractionType = {
    [InteractionType.AutoCall]: TemplateType.AUTOCALL,
    [InteractionType.SMS]: TemplateType.SMS,
    [InteractionType.Letter]: TemplateType.LETTER,
    [InteractionType.Email]: TemplateType.EMAIL,
    [InteractionType.Eboks]: TemplateType.EBOKS,
    [InteractionType.Kivra]: TemplateType.EBOKS,
    [InteractionType.Digipost]: TemplateType.EBOKS,
    [InteractionType.ClientNote]: TemplateType.CREDITOR_MESSAGE,
    [InteractionType.DebtorNote]: TemplateType.DEBTOR_MESSAGE,
    [InteractionType.Note]: TemplateType.NOTE,
};
export const getTemplateTypeForInteractionType = (type) => templateTypeByInteractionType[type] ?? null;
const interactionTypeByTemplateType = {
    [TemplateType.AUTOCALL]: InteractionType.AutoCall,
    [TemplateType.SMS]: InteractionType.SMS,
    [TemplateType.LETTER]: InteractionType.Letter,
    [TemplateType.EMAIL]: InteractionType.Email,
    [TemplateType.EBOKS]: InteractionType.Eboks,
    [TemplateType.CREDITOR_MESSAGE]: InteractionType.ClientNote,
    [TemplateType.DEBTOR_MESSAGE]: InteractionType.DebtorNote,
};
export const getInteractionTypeForTemplateType = (type) => interactionTypeByTemplateType[type] ?? null;
export var TemplateThemePaths;
(function (TemplateThemePaths) {
    TemplateThemePaths["PLAIN"] = "defaults/plain/default";
    TemplateThemePaths["PLAIN_WITH_LOGO"] = "defaults/plain/default-with-logo";
    TemplateThemePaths["PLAIN_RKI"] = "defaults/plain/rki";
    TemplateThemePaths["PLAIN_RKI_DEBITOR_REGISTRET"] = "defaults/plain/rki-debitor-registret";
    TemplateThemePaths["PLAIN_WITH_HEADER"] = "defaults/plain/default-with-header";
    TemplateThemePaths["PLAIN_WITH_HEADER_CREDITORS"] = "defaults/plain/default-with-header-creditors";
    TemplateThemePaths["PLAIN_WITH_HEADER_VOUCHER_REFERENCES"] = "defaults/plain/default-with-header-voucher-references";
})(TemplateThemePaths || (TemplateThemePaths = {}));
export var TemplateMention;
(function (TemplateMention) {
    TemplateMention["GENERIC_EMAIL_SUBJECT"] = "{{genericEmailSubject}}";
    TemplateMention["DEPOSIT"] = "{{formattedFields.financials.deposit}}";
    TemplateMention["FINANCIALS_INTERESTS"] = "{{formattedFields.financials.interests}}";
    TemplateMention["FINANCIALS_INTEREST_RATE"] = "{{formattedFields.financials.interestRate}}";
    TemplateMention["FINANCIALS_DEBT_COLLECTION_COSTS"] = "{{formattedFields.financials.debtCollectionCosts}}";
    TemplateMention["FINANCIALS_PRICIPAL"] = "{{formattedFields.financials.principal}}";
    TemplateMention["FINANCIALS_ADMINISTRATION_COSTS"] = "{{formattedFields.financials.administrationCosts}}";
    TemplateMention["FINANCIALS_COMPENSATION_FEES"] = "{{formattedFields.financials.compensationFees}}";
    TemplateMention["FINANCIALS_DEBT_COLLECTION_FEES"] = "{{formattedFields.financials.debtCollectionFees}}";
    TemplateMention["REMINDER_FEES"] = "{{formattedFields.financials.reminderFees}}";
    TemplateMention["TOTAL_DEBT"] = "{{formattedFields.financials.totalDebt}}";
    TemplateMention["OVERPAYMENT"] = "{{formattedFields.financials.overpayment}}";
    TemplateMention["ACCORD_TEN_PERCENT"] = "{{formattedFields.financials.tenPercentAccord}}";
    TemplateMention["ACCORD_TWENTY_PERCENT"] = "{{formattedFields.financials.twentyPercentAccord}}";
    TemplateMention["ACCORD_THIRTY_PERCENT"] = "{{formattedFields.financials.thirtyPercentAccord}}";
    TemplateMention["ACCORD_FORTY_PERCENT"] = "{{formattedFields.financials.fortyPercentAccord}}";
    TemplateMention["ACCORD_FIFTY_PERCENT"] = "{{formattedFields.financials.fiftyPercentAccord}}";
    TemplateMention["ACCORD_SIXTY_PERCENT"] = "{{formattedFields.financials.sixtyPercentAccord}}";
    TemplateMention["ACCORD_SEVENTY_PERCENT"] = "{{formattedFields.financials.seventyPercentAccord}}";
    TemplateMention["ACCORD_EIGHTY_PERCENT"] = "{{formattedFields.financials.eightyPercentAccord}}";
    TemplateMention["ACCORD_NINETY_PERCENT"] = "{{formattedFields.financials.ninetyPercentAccord}}";
    TemplateMention["LAST_PAYMENT_AMOUNT"] = "{{formattedFields.financials.lastPaymentAmount}}";
    TemplateMention["LAST_PAYMENT_DATE"] = "{{formattedFields.financials.lastPaymentDate}}";
    TemplateMention["CURRENCY"] = "{{currency}}";
    TemplateMention["PRINCIPAL_REFERENECE_IDS"] = "{{formattedFields.financials.principalReferenceIds}}";
    TemplateMention["DEPOSITS_TO_CREDITOR"] = "{{formattedFields.financials.depositedToCreditor}}";
    TemplateMention["DEPOSITS_TO_COLLECTOR"] = "{{formattedFields.financials.depositedToCollector}}";
    TemplateMention["INTEREST_PAID_LAST_YEAR"] = "{{formattedFields.financials.interestPaidLastYear}}";
    TemplateMention["DEBTOR_TABLE"] = "{{{debtorTable}}}";
    TemplateMention["CONTACT_NAME"] = "{{contact.name}}";
    TemplateMention["CONTACT_ADDRESS"] = "{{contact.address.address}}";
    TemplateMention["CONTACT_COADDRESS"] = "{{contact.address.coAddress}}";
    TemplateMention["CONTACT_ZIPCODE"] = "{{contact.address.zipcode}}";
    TemplateMention["CONTACT_CITY"] = "{{contact.address.city}}";
    TemplateMention["CONTACT_COUNTRY"] = "{{contact.address.country}}";
    TemplateMention["CONTACT_ADDRESS_INLINE"] = "{{contactAddressInline}}";
    TemplateMention["CONTACT_ADDRESS_FORMATTED"] = "{{{contactAddressFormatted}}}";
    TemplateMention["ALTERNATIVE_CONTACT_REFERENCE_ID"] = "{{contact.alternativeContactReferenceId}}";
    TemplateMention["HAS_ALTERNATIVE_CONTACT_REFERENCE_ID"] = "{{#if contact.alternativeContactReferenceId}}";
    TemplateMention["DEBTOR_ADDRESS_INLINE"] = "{{debtorAddressInline}}";
    TemplateMention["DEBTOR_ADDRESS_FORMATTED"] = "{{{debtorAddressFormatted}}}";
    TemplateMention["DEBTOR_NAME"] = "{{debtor.name}}";
    TemplateMention["DEBTOR_FIRST_NAME"] = "{{debtor.firstName}}";
    TemplateMention["DEBTOR_ADDRESS"] = "{{debtor.address.address}}";
    TemplateMention["DEBTOR_COADDRESS"] = "{{debtor.address.coAddress}}";
    TemplateMention["DEBTOR_ZIPCODE"] = "{{debtor.address.zipcode}}";
    TemplateMention["DEBTOR_CITY"] = "{{debtor.address.city}}";
    TemplateMention["DEBTOR_COUNTRY"] = "{{debtor.address.country}}";
    TemplateMention["DEBTOR_PHONE"] = "{{debtor.phone.number}}";
    TemplateMention["DEBTOR_EMAIL"] = "{{debtor.email}}";
    TemplateMention["DEBTOR_CVR_AND_OR_CPR"] = "{{cvrAndOrCpr}}";
    TemplateMention["DEBTOR_SEQ_ID"] = "{{debtor.id}}";
    TemplateMention["CREDITOR_NAME"] = "{{case.creditor.name}}";
    TemplateMention["CASE_ID"] = "{{case.id}}";
    TemplateMention["CASE_REFERENCE_ID"] = "{{customer.referenceId}}";
    TemplateMention["CREDITOR_ADDRESS"] = "{{case.creditor.address.address}}";
    TemplateMention["CREDITOR_ZIPCODE"] = "{{case.creditor.address.zipcode}}";
    TemplateMention["CREDITOR_CITY"] = "{{case.creditor.address.city}}";
    TemplateMention["CREDITOR_COMPANY_IDENTIFIER"] = "{{creditorCentralRegisterId}}";
    TemplateMention["CREDITOR_IF_IS_COMPANY"] = "{{#if case.creditor.isCompany}}";
    TemplateMention["CREDITOR_IF_IS_VAT_REGISTERED"] = "{{#if case.creditor.vatRegistered}}";
    TemplateMention["IF_ULTIMATE_CREDITOR"] = "{{#if case.ultimateCreditor}}";
    // The creditor on the case, never overridden by the ultimate creditor
    TemplateMention["CASE_CREDITOR_NAME"] = "{{case.caseCreditor.name}}";
    TemplateMention["CASE_CREDITOR_ADDRESS"] = "{{case.caseCreditor.address.address}}";
    TemplateMention["CASE_CREDITOR_ZIPCODE"] = "{{case.caseCreditor.address.zipcode}}";
    TemplateMention["CASE_CREDITOR_CITY"] = "{{case.caseCreditor.address.city}}";
    TemplateMention["CASE_CREDITOR_COMPANY_IDENTIFIER"] = "{{case.caseCreditor.centralRegisterId}}";
    TemplateMention["USER_NAME"] = "{{user.name}}";
    TemplateMention["USER_FIRST_NAME"] = "{{user.firstName}}";
    TemplateMention["IF_USER"] = "{{#if user}}";
    TemplateMention["PAYMENT_ID"] = "{{payment.id}}";
    TemplateMention["DATE"] = "{{date}}";
    TemplateMention["DATE_IN_THREE_DAYS"] = "{{formattedFields.dateInThreeDays}}";
    TemplateMention["DATE_IN_SIX_DAYS"] = "{{formattedFields.dateInSixDays}}";
    TemplateMention["DATE_IN_TEN_DAYS"] = "{{formattedFields.dateInTenDays}}";
    TemplateMention["DATE_IN_ELEVEN_DAYS"] = "{{formattedFields.dateInElevenDays}}";
    TemplateMention["DATE_IN_TWELVE_DAYS"] = "{{formattedFields.dateInTwelveDays}}";
    TemplateMention["DATE_IN_FOURTEEN_DAYS"] = "{{formattedFields.dateInFourteenDays}}";
    TemplateMention["DATE_IN_SEVENTEEN_DAYS"] = "{{formattedFields.dateInSeventeenDays}}";
    TemplateMention["DATE_IN_THIRTY_DAYS"] = "{{formattedFields.dateInThirtyDays}}";
    TemplateMention["PREVIOUS_THREE_YEARS"] = "{{formattedFields.previousThreeYears}}";
    TemplateMention["BANK_CREDITOR_NUMBER"] = "{{formattedFields.bankCreditorNumber}}";
    TemplateMention["DOCUMENTATION"] = "{{{documentationHTML}}}";
    TemplateMention["IF_IS_COMPANY"] = "{{#if case.isCompany}}";
    TemplateMention["IF_DEBTOR_IS_DEBT_REGISTERED"] = "{{#if debtRegister.isRegistered}}";
    TemplateMention["IF_CASE_HAS_MULTIPLE_PRINCIPALS"] = "{{#if formattedFields.financials.hasMultiplePrincipals}}";
    TemplateMention["IF_CASE_HAS_REMINDER_FEES"] = "{{#if formattedFields.financials.showReminderFees}}";
    TemplateMention["IF_CASE_HAS_COLLECTION_FEES"] = "{{#if formattedFields.financials.showDebtCollectionFees}}";
    TemplateMention["IF_CASE_HAS_COLLECTION_COSTS"] = "{{#if formattedFields.financials.showDebtCollectionCosts}}";
    TemplateMention["IF_CASE_HAS_COMPENSATION_COSTS"] = "{{#if formattedFields.financials.showCompensationFees}}";
    TemplateMention["IF_CASE_HAS_PROCESSRENTE"] = "{{#if formattedFields.financials.showInterests}}";
    TemplateMention["IF_CASE_HAS_FIXED_INTEREST"] = "{{#if formattedFields.financials.showFixedInterest}}";
    TemplateMention["IF_CASE_HAS_YEARLT_INTEREST"] = "{{#if formattedFields.financials.showYearlyInterest}}";
    TemplateMention["IF_CASE_HAS_DEPOSIT"] = "{{#if formattedFields.financials.hasDeposit}}";
    TemplateMention["PAYMENT_LINK"] = "{{directPaymentLink}}";
    TemplateMention["OVERPAYMENT_LINK"] = "{{overpaymentLink}}";
    TemplateMention["OVERPAYMENT_LINK_QR_CODE"] = "{{{overpaymentLinkQRCode}}}";
    TemplateMention["OVERPAYMENT_LINK_A_TAG"] = "{{{overpaymentLinkATag}}}";
    TemplateMention["PAYMENT_PLAN_LINK"] = "{{paymentPlanLink}}";
    TemplateMention["DEBTOR_WEB_LINK"] = "{{debtorWebLink}}";
    TemplateMention["DEBTOR_WEB_LONG_LINK"] = "{{debtorWebLongLink}}";
    TemplateMention["PAYMENT_LINK_QR_CODE"] = "{{{directPaymentLinkQRCode}}}";
    TemplateMention["PAYMENT_PLAN_LINK_QR_CODE"] = "{{{paymentPlanLinkQRCode}}}";
    TemplateMention["DEBTOR_WEB_LINK_QR_CODE"] = "{{{debtorWebLinkQRCode}}}";
    TemplateMention["PAYMENT_PLAN_LENGTH_IN_DAYS"] = "{{paymentPlan.lengthInDays}}";
    TemplateMention["PAYMENT_LINK_A_TAG"] = "{{{directPaymentLinkATag}}}";
    TemplateMention["PAYMENT_PLAN_LINK_A_TAG"] = "{{{paymentPlanLinkATag}}}";
    TemplateMention["DEBTOR_WEB_LINK_A_TAG"] = "{{{debtorWebLinkATag}}}";
    TemplateMention["DEBTOR_WEB_LONG_LINK_A_TAG"] = "{{{debtorWebLongLinkATag}}}";
    TemplateMention["PAYMENT_PLAN_ENTRIES_TAG"] = "{{{paymentPlanEntriesTag}}}";
    TemplateMention["PAYMENT_PLAN_STATUS_TAG"] = "{{{paymentPlanStatusTag}}}";
    TemplateMention["PAYMENT_PLAN_CREATION_DATE"] = "{{paymentPlan.createdAt}}";
    TemplateMention["PAYMENT_PLAN_ENTRY_AMOUNT"] = "{{paymentPlan.amount}}";
    TemplateMention["PAYMENT_PLAN_ENTRY_DEADLINE"] = "{{paymentPlan.deadline}}";
    TemplateMention["PAYMENT_PLAN_ENTRY_DATE"] = "{{paymentPlan.date}}";
    TemplateMention["PAYMENT_PLAN_HTML"] = "{{{paymentPlan.planHTML}}}";
    TemplateMention["PaymentPlanAmortisation"] = "{{{paymentPlan.amortisationHTML}}}";
    TemplateMention["PAYMENT_PLAN_FIRST_AMOUNT"] = "{{paymentPlan.firstEntry.amount}}";
    TemplateMention["PAYMENT_PLAN_FIRST_DATE"] = "{{paymentPlan.firstEntry.date}}";
    TemplateMention["PAYMENT_PLAN_FIRST_DEADLINE"] = "{{paymentPlan.firstEntry.deadline}}";
    TemplateMention["PAYMENT_PLAN_LAST_AMOUNT"] = "{{paymentPlan.lastEntry.amount}}";
    TemplateMention["PAYMENT_PLAN_LAST_DATE"] = "{{paymentPlan.lastEntry.date}}";
    TemplateMention["PAYMENT_PLAN_LAST_DEADLINE"] = "{{paymentPlan.lastEntry.deadline}}";
    TemplateMention["PAYMENT_PLAN_YEARLY_COSTS"] = "{{{paymentPlan.yearlyCostsHTML}}}";
    TemplateMention["PaymentPlanApr"] = "{{paymentPlan.apr}}";
    TemplateMention["PAYMENT_PLAN_HAS_YEARLY_INTEREST"] = "{{#if paymentPlan.hasYearlyInterest}}";
    TemplateMention["PAYMENT_PLAN_MIN_ENTRY_AMOUNT"] = "{{paymentPlan.minEntryAmount}}";
    TemplateMention["PAYMENT_PLAN_MAX_ENTRY_AMOUNT"] = "{{paymentPlan.maxEntryAmount}}";
    TemplateMention["DK_BPK"] = "{{{DKbetalingspaakrav}}}";
    TemplateMention["GL_BPK"] = "{{{GLbetalingspaakrav}}}";
    TemplateMention["PAGE_BREAK"] = "{{{pageBreak}}}";
    TemplateMention["JOURNAL_NUMBER"] = "{{journalNumber}}";
    TemplateMention["COLLECTOR_PAYMENT_OPTIONS"] = "{{{paymentOptionsHTML}}}";
    TemplateMention["COLLECTOR_REGISTER_NUMBER"] = "{{collector.registrationNumber}}";
    TemplateMention["COLLECTOR_ACCOUNT_NUMBER"] = "{{collector.accountNumber}}";
    TemplateMention["COLLECTOR_PHONE"] = "{{collectorPhone}}";
    TemplateMention["COLLECTOR_EMAIL"] = "{{collectorEmail}}";
    TemplateMention["COLLECTOR_NICKNAME"] = "{{collector.nickname}}";
    TemplateMention["COLLECTOR_NAME"] = "{{collector.name}}";
    TemplateMention["COLLECTOR_ADDRESS_ADDRESS"] = "{{collector.address.address}}";
    TemplateMention["COLLECTOR_ADDRESS_CITY"] = "{{collector.address.city}}";
    TemplateMention["COLLECTOR_ADDRESS_ZIP"] = "{{collector.address.zipcode}}";
    TemplateMention["COLLECTOR_CVR"] = "{{collector.centralRegisterId}}";
    TemplateMention["COLLECTOR_COURT_PHONE"] = "{{collectorCourtPhone}}";
    TemplateMention["IF_COLLECTOR_ALLOWS_BANK_TRANSFERS"] = "{{#if availablePaymentOptions.bankTransfer}}";
    TemplateMention["IF_COLLECTOR_ALLOWS_FI_PAYMENTS"] = "{{#if availablePaymentOptions.fi}}";
    TemplateMention["COURT_NAME"] = "{{court.navn}}";
    TemplateMention["COURT_ADDRESS"] = "{{court.address.address}}";
    TemplateMention["COURT_CITY"] = "{{court.address.city}}";
    TemplateMention["COURT_ZIP"] = "{{court.address.zipcode}}";
    TemplateMention["COURT_EMAIL"] = "{{court.email}}";
    TemplateMention["COURT_PHONE"] = "{{court.phone}}";
    TemplateMention["COURT_EAN"] = "{{court.eanno}}";
    TemplateMention["ACCOUNT_NO"] = "{{court.accountnumber}}";
    TemplateMention["REG_NO"] = "{{court.registrationnumber}}";
    TemplateMention["SIGN_FIELDS"] = "{{{signingFields}}}";
    TemplateMention["SATISFACTION_BUTTONS"] = "{{{satisfactions.buttons}}}";
    TemplateMention["FOUNDATION_DATE"] = "{{foundationDate}}";
    TemplateMention["FOUNDATION_TYPE"] = "{{foundationType}}";
    TemplateMention["LATEST_TRIBUNAL_REFERENCE"] = "{{tribunal.latestReferenceId}}";
    TemplateMention["CONDITIONAL_END_IF"] = "{{/if}}";
    TemplateMention["CONDITIONAL_ELSE"] = "{{else}}";
})(TemplateMention || (TemplateMention = {}));
export var TemplateTag;
(function (TemplateTag) {
    TemplateTag["BPKWarning"] = "BPK_WARNING";
    TemplateTag["DebtRegistrationWarning"] = "DEBT_REGISTRATION_WARNING";
})(TemplateTag || (TemplateTag = {}));
//# sourceMappingURL=index.js.map